import React from 'react'
import PropTypes from 'prop-types'
import { classNames } from 'utils/utils'
import withStyle from './AffinityIcon.style'

const paths = {
  0: (
    <path
      fill="#00B7BF"
      fillRule="nonzero"
      d="M1.126 9.5h9.748A5.992 5.992 0 0 1 6 12a5.992 5.992 0 0 1-4.874-2.5zm10.685-2H2.797L9.305.992A6.01 6.01 0 0 1 11.811 7.5zM.146 7.322A6 6 0 0 1 7.322.146L.146 7.322z"
    />
  ),
  1: (
    <path
      fill="#DE9112"
      fillRule="nonzero"
      d="M5 8h2v3.917a6.04 6.04 0 0 1-2 0V8zm0-2V.083A6 6 0 0 1 12 6H5zm6.659 2A6.019 6.019 0 0 1 9 11.197V8h2.659zM.34 8H3v3.197A6.019 6.019 0 0 1 .341 8zM0 6C0 3.78 1.207 1.84 3 .803V6H0z"
    />
  ),
  2: (
    <path
      fill="#FE01B8"
      fillRule="nonzero"
      d="M.666 8.75h10.668A6 6 0 0 1 6 12 6 6 0 0 1 .666 8.75zm-.62-2a6 6 0 1 1 11.907 0H.047z"
    />
  ),
  3: (
    <path
      fill="#B4040C"
      fillRule="nonzero"
      d="M.083 7a6.04 6.04 0 0 1 0-2h11.834a6.04 6.04 0 0 1 0 2H.083zm.72 2h10.394A5.998 5.998 0 0 1 6 12 5.998 5.998 0 0 1 .803 9zm0-6A5.998 5.998 0 0 1 6 0c2.22 0 4.16 1.207 5.197 3H.803z"
    />
  ),
  4: (
    <path
      fill="#0B2E6B"
      fillRule="nonzero"
      d="M0 6h5v5.917A6.002 6.002 0 0 1 0 6zm.341-2A6.002 6.002 0 0 1 11.66 4H.34zM12 6a6.002 6.002 0 0 1-5 5.917V6h5z"
    />
  ),
  5: (
    <path
      fill="#08AE83"
      fillRule="nonzero"
      d="M1.555 1.97l8.476 8.475a6.002 6.002 0 0 1-1.797 1.125L.487 3.823l-.128.13a5.998 5.998 0 0 1 1.196-1.984zM3.14.724a6 6 0 0 1 8.136 8.136L3.14.725zm2.695 11.273A6 6 0 0 1 .002 6.166l5.832 5.832z"
    />
  ),
  6: (
    <path
      fill="#0A5E7A"
      fillRule="nonzero"
      d="M3.185 11.3a6.027 6.027 0 0 1-1.89-1.575l8.43-8.43a6.027 6.027 0 0 1 1.575 1.89L3.185 11.3zm2.164.665l6.616-6.616a6 6 0 0 1-6.616 6.616zM.303 7.89A6 6 0 0 1 7.89.303L.303 7.89z"
    />
  ),
  7: (
    <path
      fill="#690EB9"
      fillRule="nonzero"
      d="M5 11.917V.083a6 6 0 1 1 0 11.834zm-2-.72A5.998 5.998 0 0 1 0 6C0 3.78 1.207 1.84 3 .803v10.394z"
    />
  ),
}

const AffinityIcon = ({ groupNumber, className, onClick, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={classNames(className, 'relation-symbol', 'affinity-icon')}
    viewBox="0 0 12 12"
    onClick={onClick}
  >
    {paths[groupNumber]}
  </svg>
)

AffinityIcon.propTypes = {
  /** ordinal group number */
  groupNumber: PropTypes.number,
  /** The class name */
  className: PropTypes.string,
  /** Width (also height) of the image */
  width: PropTypes.number,
  /** click handler for the thing */
  onClick: PropTypes.func,
}
AffinityIcon.defaultProps = {
  width: 20,
}

export default withStyle(AffinityIcon)
